// extracted by mini-css-extract-plugin
export default {"root":"_2Yp0f","text-block":"_3c49V","textBlock":"_3c49V","prefix":"_3pso5"};